import api from './api'

const permitService = {}

permitService.all = async function() {
    return api.get('/UsuarioPermiso').then(res => res.data);
}

export default permitService